export default {
    Email: '電子メール',
    ConfirmEmail: 'メールアドレスを確認する',
    Password: 'パスワード',
    Verificationcode: '確認コード',
    AlreadyhaveaHitPawaccountLogin: 'HitPawのアカウントをお持ちですか？ログイン',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'HitPawに登録することで、当社の利用規約およびプライバシーポリシーに同意したものとします。',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'HitPawにログインすることで、当社の利用規約およびプライバシーポリシーに同意したものとします。',
    Byproceedingyouagreetoour: 'HitPawに登録/ログインすることで、当社の',
    ServicesofUse: '利用規約',
    and: 'および',
    PrivacyPolicy: 'プライバシーポリシーに',
    last: '同意したものとします。',
    Pleaseenterthesameemailinbothfields:
        '両方のフィールドに同じメールアドレスを入力してください。',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'パスワードには、文字数が8文字以上50文字以下で、英数字、特殊文字が少なくとも2種類含まれてください。',
    Incorrectverificationcode: '認証コードが正しくありません',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'このメールアドレスは登録済みです。別のメールアドレスを選択してください。',
    Cannotbeemptyhere: '空白にすることはできません',
    Rememberme: 'ログインしたままにする',
    ForgotPassword1: 'パスワードが忘れた場合',
    NotaregistereduseryetSignUp: 'また登録していませんか？登録',
    Notaregistereduseryet1: 'また登録していませんか？',
    Notaregistereduseryet2: '登録',
    NoaccountfoundwiththatEmailaddress:
        'アカウントが存在しません。メールアドレスをご確認ください。',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'メールアドレスまたはパスワードが間違っていました。もう一度やり直してください。',
    ForgotPassword2: 'パスワードが忘れた',
    GetVerificationCode: '確認コードを取得する',
    VerifyEmail: 'メール認証',
    Ithasbeensenttoyourmailboxpleasecheckit:
        '指定したメールアドレスに送信しました。受信トレイをご確認ください。',
    PleaseinputEmailaddress: 'メールアドレスを入力してください',
    TheEmailformatisincorrect: '電子メールの形式が正しくありません',
    TheEmailisnotregistered: 'このメールアドレスが登録されていません',
    Invalidverificationcodepleasereenterthecorrectone:
        '無効な確認コードです。正しい確認コードを入力してください',
    Resetpassword: 'パスワードを再設定する',
    Emailaddressverificationsucceeded: 'メールアドレスの認証に成功しました',
    Pleaseresetyourpassword: 'パスワードを再設定してください',
    Enteranewpassword: '新しいパスワードを入力してください',
    Confirm: '確認',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        '新しいパスワードには、文字数が8文字以上50文字以下で、英数字、特殊文字が少なくとも2種類含まれてください。',
    Passwordresetsuccessfully: 'パスワードの変更に成功しました',
    Name: '名前',
    GetCode: 'コードを取得',
    Loginsuccessful: 'ログインに成功しました。',
    Loginfailed: 'ログインに失敗しました。',
    Signupsuccessful: '登録に成功しました。',
    Signupfailed: '登録に失敗しました。',
    Getpassword: 'パスワードを取得する',
    Authorizationhasexpiredpleaseloginagain:
        '認証の有効期限が切れました。再度ログインしてください。',
    Sorrysomethingwentwrongpleasetryagainlater:
        'リクエストにエラーが発生しました。しばらくしてからもう一度お試しください。',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'リクエストが多過ぎます。しばらくしてからもう一度お試しください。',
    Couldntfindyouraccountorthepasswordisincorrect:
        'アカウントが見つからなかったか、またはパスワードが正しくありません。',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'プレミアム機能へアクセスするには、まずはご登録ください。',
    Accessdeniedfortheunauthorizedrequest:
        'アクセス許可がありませんので、アクセスが拒否されました。',
    Alreadyhaveaccount: '既にアカウントがありますか？',
    SignUpwithemail: '電子メールでサインアップ',
    Securityverification: 'セキュリティ検証',
    Pleaseenterthecorrectemailaddress: '正しいメールアドレスを入力してください！',
    PleaseInputverificationCode: '認証コードを入力してください！！',
    Pleaseenterthesamepasswordinbothfields:
        '両方のフィールドに同じパスワードを入力してください！',
    or: 'or',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        '入力した新しいパスワードは、現在のパスワードと同じです。別のパスワードを入力してください',
    YourpasswordwasincorrectPleasetryagain:
        'パスワードが間違っていました。もう一度やり直してください。',
    reg400: 'リクエストにエラーが発生しました。しばらくしてからもう一度お試しください。',
    reg400223: '電子メールと認証コードが一致しません。ご確認ください。',
    reg400224: 'トークンの有効期限が切れています',
    500: 'サーバ側エラー!',
    ContinuewithGoogle: 'Googleで続ける',
    ContinuewithEmail: '電子メールで続ける',
    LoginwithEmail: '電子メールでログインする',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        '8文字以上使用し、文字、数字、記号を混在させる（サポート記号：@$!%*#_~?&^）',
    ConfirmPassword: 'パスワード確認',
    Pleaseloginwithemail: '電子メールでログインしてください',
    youraccount: 'お客様のアカウント',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        'はすでに存在しています。アカウントの安全性を確保するため、まず認証を完了してください。',
    Login: 'ログイン',
    exceed6Times: 'トライアルは本日終了しました。すべてのプレミアム機能にアクセスするには、Pro にアップグレードしてください。',
    exceed20M: '無料アカウントのファイル サイズは 20 MB を超えることはできません。すべてのプレミアム機能にアクセスするには、Pro にアップグレードしてください。'
}